export enum TipoDeficiencia {
  Nenhuma = 0, 
  Fisica = 1, 
  Visual = 2, 
  Auditiva = 3, 
  Intelectual = 4, 
  Psicossocial = 5, 
  Multipla = 6
}